/*
 * @Author: bbqin
 * @Date: 2022-01-11 11:18:26
 * @LastEditTime: 2023-09-02 14:13:02
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { BaseComponent } from '@platform/template';
import { Tooltip } from '@platform/base';
import classNames from 'classnames';
import { getMultiLang, getSysFieldid, getGlobalStorage } from '@platform/api';
import useSmartCard from './store';
import Container from './components/container';
import CardList from './components/cardList';
import CardWallet from './components/wallet';
import ManagerOverlay from './components/manager';
import { Preset, isBoolean, isFunction, isPromise, Closest } from './libs/utils';
import EmptyPrompt from './components/empty';
import AnimateRotateIcon from './components/animation';
import Message from './components/message';
import Portal from './components/portal';
import Skeleton from './components/skeleton';

const { ContainerItem } = Container;

/**
 * 创建单来源组件
 * @memberof SmartCard
 * @component CreateSmartCard | SmartCard
 * @property {boolean} [showSortIcon = true] - 是否显示排序按钮
 * @property {boolean} [draggable = true] - 是否拖拽排序
 * @property {WalletConfig} [defaultWalletConfig = {}] - 如果config里传了属性  如title，则传入的属性优先级最高，比api修改的属性还高
 * @property {WalletConfig} [walletConfig = {}] - 也可以设置某个id下属性 walletId: {title: 'test'}
 * @property {WalletCardConfig} [defaultCardConfig = {}] - 卡片配置项
 * @property {WalletCardConfig} [cardConfig = {}] - 也可以设置某个id下属性 cardId: {title: 'test'}
 * @property {string} [containerHeight = null] - 组件高度
 * @property {string} [containerClassName = ''] - 组件样式类扩展
 * @property {boolean} [isPortal = false] - 是不是门，用于通信和展示隐藏的组件
 * @property {object} [disabledVisibleCache = {}] - 禁止用户控制显隐性的项，disabledVisibleCache: {  tab1: { wallet_7: true,  wallet_4: true, }, }
 * @property {BillInfo} [pageInfo = {}] -  pageInfo  页面信息 appcode、pagecode 用于缓存数据
 * @property {boolean} [isPretreatmentCard = true] - 内部生成智能审核和审批详情页签
 * @property {boolean} [isHideOrigin = true] - 是否隐藏门里的业务助手
 * @property {string} [expectActiveTab = ''] - 期望页签  approval  auditing
 * @property {object} [tabPanelForceRender = {}] - 强制渲染页面内容（一般是激活页签才渲染），eg. {tab1: true, tab2: false, tab3: true}
 *
 * @property {function(tabKey): null} [onTabClick = null] - 页签激活事件
 * @property {function(array<tabKey>): ReactNode} [tabsRender = null] - 自定义页签渲染
 * @property {function(): ReactNode} [emptyContent = null] - 整个容器的空状态显示
 * @property {function(): ReactNode} [tabBarExtraContent = null] - 页签右侧额外区域
 */

const defaultProps = {
    // 公共部分的设置
    prefixCls: 'smart-card',
    name: 'smartCard',
    // 排序按钮
    showSortIcon: true,
    // 整个容器的空状态显示
    emptyContent: null,
    // 页签激活事件
    onTabClick: null,
    // 页签右侧额外区域
    tabBarExtraContent: null,
    // 页签panel没有数据的显示
    panelEmptyContent: null,
    // 拖拽排序
    draggable: true,

    // 如果config里传了属性  如title，则传入的属性优先级最高，比api修改的属性还高
    // 卡片组
    defaultWalletConfig: { emptyContent: null },
    // 也可以设置某个id下属性 walletId: {title: 'test'}
    walletConfig: {},
    // 卡片配置项
    defaultCardConfig: { emptyContent: null },
    // 也可以设置某个id下属性 cardId: {title: 'test'}
    cardConfig: {},

    // 自定义页签渲染
    tabsRender: null,

    // 页签内容强制渲染
    tabPanelForceRender: {},

    // 高度
    containerHeight: null,
    // 样式
    containerClassName: '',

    // 禁止用户控制显隐性
    disabledVisibleCache: {},

    // 是不是门，用于通信和展示隐藏的组件
    isPortal: false,

    // pageInfo  页面信息 appcode、pagecode 用于缓存数据
    pageInfo: {},

    // 内部生成智能审核和审批详情页签
    isPretreatmentCard: true,

    // 是否隐藏门里的业务助手
    isHideOrigin: true,

    // 自动化
    fieldid: 'smart_card',

    // 期望页签  tab_auditing  tab_approve
    expectActiveTab: [],
};

require('./index.less');

const PresetTabs = [Preset.auditing.tabId, Preset.approval.tabId];

class SmartCard extends BaseComponent {
    constructor(props) {
        super(props);
        const { store, id, visible = true, expectActiveTab = [], pageInstance, isPortal } = props;

        this.state = { forceVisible: true };

        store.setStore('id', id, false);
        store.setStore('visible', visible, false);
        store.setStore('isPortal', isPortal, false);
        expectActiveTab.length && store.setStore('expectActiveTab', expectActiveTab, false);

        const topic = Message.getName('channel');
        Message.subscribe(topic, this.handleMessageSubscribe);

        this.isMounted = false;
    }

    /**
     * 订阅事件，作为独立方法，可以避免销毁时无法找到目标
     * @ignore
     * @param {string} data
     */
    handleMessageSubscribe(data) {
        const { store, id, visible = true, pageInstance, isPortal } = this.props;
        const topic = Message.getName('channel');
        const { name, params = [] } = data;
        console.log(topic, data);
        if (name && params.length) {
            params[0] = id;
            const api = (pageInstance?.smartCard || {})[name];
            if (api) {
                const result = api(...params);
            }
        }
    }

    componentWillUnmount() {
        const topic = Message.getName('channel');

        const { isPortal } = this.props;

        Message.unsubscribe(topic, this.handleMessageSubscribe);
        // 解决get方法获取不了数据的问题
        Portal.uninstallGlobal();
        // 移除标志
        isPortal && Portal.removePortalSign();
    }

    componentWillMount() {
        const { store } = this.props;

        //调用多语
        let callback = (json) => {
            store.setStore('langJson', json, false);
            this.setState({ langJson: json });
        };
        getMultiLang({ moduleId: 'containers_smart_card', callback });
    }

    componentDidMount() {
        const { store, id, pageInstance, isPortal, isHideOrigin, ...others } = this.props;

        // 绑定写在这里，避免多次渲染时，出现渲染错误问题
        // 门，给全局
        if (isPortal) {
            Portal.addPortalSign();
        }
        // 解决iframe外get方法获取不了数据的问题
        Portal.installGlobal(pageInstance, id);

        // 如果有portal，当前是global，则隐藏父级的分栏
        const portals = Portal.getPortal();
        if (!isPortal && portals.length && isHideOrigin) {
            const $current = ReactDOM.findDOMNode(this);
            // 左右分栏
            const $dragColumn = Closest($current, '.dragWidthCom');
            if ($dragColumn) {
                const $dragLine = $dragColumn.querySelector('.dragWidthCom_line');
                const $dragColumnRight = $dragColumn.querySelector('.dragWidthCom_right');
                $dragColumn.setAttribute('hide-col', 'right');

                $dragLine && ($dragLine.style.display = 'none');
                $dragColumnRight && ($dragColumnRight.style.display = 'none');
            }

            // TODO 是否要把内部的元素真实隐藏
            $current && ($current.style.display = 'none');
            store.setStore('isPortalStartup', true, false);

            this.setState({ forceVisible: false });
        }

        let metaObj = store.getViewMeta(id);
        if (!metaObj) {
            return null;
        }
        const { container } = metaObj;
        const visible = store.getContainerProps('visible');
        if (!container || !visible) {
            return null;
        }

        this.isMounted = true;

        // const nextMeta = store.getMeta();
        // const metaLang = store.getMetaLang();
        // const currentTs = store.getStore('ts');
        let nextBillInfo = store.getStore('billInfo');

        // 即将绑定
        Message.publish(Message.getName('mount'), {
            mounted: true,
            id: id,
            billInfo: nextBillInfo,
            // layout: nextMeta,
            // config: others,
            // metaLang: metaLang,
            // ts: currentTs,
        });
    }

    componentDidUpdate() {
        // 只触发一次mounted
        if (!this.isMounted) {
            const { store, id, pageInstance, ...others } = this.props;
            let metaObj = store.getViewMeta(id);
            if (!metaObj) {
                return null;
            }
            const { container } = metaObj;
            const visible = store.getContainerProps('visible');
            if (!container || !visible) {
                return null;
            }

            this.isMounted = true;

            // const nextMeta = store.getMeta();
            // const metaLang = store.getMetaLang();
            // const currentTs = store.getStore('ts');

            let nextBillInfo = store.getStore('billInfo');

            // 即将绑定
            Message.publish(Message.getName('mount'), {
                mounted: true,
                id: id,
                billInfo: nextBillInfo,
                // config: others,
                // layout: nextMeta,
                // metaLang: metaLang,
                // ts: currentTs,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { expectActiveTab, store } = nextProps;
        // expectActiveTab.length && store.setStore('expectActiveTab', expectActiveTab, false);
    }

    // 向外通信
    feedbackMessage(data, topic) {
        topic = topic || Message.getName('feedback');
        Message.publish(topic, data);
    }

    // 关联页面的对象
    getPageInstanceByPortal = () => {
        const { store, id, pageInstance, ...others } = this.props;

        const hasPortalSign = Portal.hasPortalSign();
        let result = pageInstance;

        // iframe外初始化组件属性
        if (hasPortalSign) {
            const globalAPI = Portal.getGlobal();
            if (globalAPI.length) {
                // 调用getSmartCard获取数据
                globalAPI.forEach((smartCard) => {
                    const { pageScope, id } = smartCard || {};
                    if (!pageScope) {
                        console.log('没有找到对应的pageScope');
                    } else {
                        result = pageScope;
                        return;
                    }
                });
            }
        }

        return result;
    };

    getEmptyContent() {
        const { emptyContent, store, prefixCls } = this.props;
        const langJson = store.getStore('langJson');

        const dom = (
            <div className={`${prefixCls}-empty-content`}>
                <i className={`${prefixCls}-empty-img`}></i>
                <span>{langJson['container-empty-content']}</span>
            </div>
        );
        return <div className={`${prefixCls}-empty`}>{typeof emptyContent === 'function' ? emptyContent() : dom}</div>;
    }

    // 处理传入的config，优先级最高
    handleConfig() {
        let { store, walletConfig, cardConfig, defaultWalletConfig = {}, defaultCardConfig = {}, expandFlag } = this.props;
        if (store) {
            const expandFlagConfig = isBoolean(expandFlag) ? { expandFlag } : {};
            // console.time('handleConfig');
            const idRelation = store.getStore('idRelation');
            const walletsModuleIdRelation = idRelation?.wallets?.moduleId || {};
            const cardsModuleIdRelation = idRelation?.cards?.moduleId || {};
            Object.keys(walletsModuleIdRelation).forEach((walletId) => {
                const walletProps = walletConfig[walletId];
                const currentProps = { ...defaultWalletConfig, ...walletProps };
                for (const key in currentProps) {
                    if (Object.hasOwnProperty.call(currentProps, key)) {
                        const value = currentProps[key];
                        store.setCardWalletProps(walletId, key, value, false);
                    }
                }
            });

            Object.keys(cardsModuleIdRelation).forEach((cardId) => {
                const cardProps = cardConfig[cardId] || {};
                const currentProps = { ...expandFlagConfig, ...defaultCardConfig, ...cardProps };
                for (const key in currentProps) {
                    if (Object.hasOwnProperty.call(currentProps, key)) {
                        const value = currentProps[key];
                        store.setCardProps(cardId, key, value, false);
                    }
                }

                // 判断下预置页签是否显示 如果是，强制刷新下预置页签，解决config里属性修改了，但是预置页签不刷新的问题
                // if ([Preset.auditing.cardId, Preset.approval.cardId].includes(cardId)) {
                if ([Preset.auditing.cardId].includes(cardId)) { //这行代码会导致共享智能审核死循环 但去掉会导致财务付款单不显示智能审核
                    store.reloadPretreatmentCard([cardId], undefined, false);
                }
            });
            // console.timeEnd('handleConfig');
        }
    }

    getContainer() {
        let {
            prefixCls,
            store,
            id,
            onTabClick,
            pageInstance,
            tabBarExtraContent: finalTabBarExtraContent,
            panelEmptyContent,
            draggable,

            tabsRender,

            walletConfig,
            cardConfig,
            onRefresh,
            showRefresh,
            tabPanelForceRender,
        } = this.props;

        const { forceVisible } = this.state;

        let meta = store.getViewMeta(id);

        if (!meta || !forceVisible) {
            return null;
        }

        const { container, walletLists, cardLists, cardStores } = meta;
        const visible = store.getContainerProps('visible');
        if (!container || !visible) {
            return this.getEmptyContent();
            // return null;
        }

        // 处理外部传入的config，在这里处理可以避免meta没有或者子组件没有渲染导致的config没有同步成功的问题
        this.handleConfig();

        let visibleTabs = store.getTabs((props) => props.visible !== false);
        if (!visibleTabs.length) {
            // return null;
            return this.getEmptyContent();
        }

        visibleTabs = isFunction(tabsRender) ? tabsRender(visibleTabs) : visibleTabs;

        const langJson = store.getStore('langJson');
        const activeKey = store.getContainerActiveTab(visibleTabs);

        const portalPageInstance = this.getPageInstanceByPortal();

        const items = visibleTabs.map((element, index) => {
            const { $id, props = {} } = element;
            const { moduleId, render } = props;

            // 当前页签的属性
            const currentTabProps = store.getTabProps(moduleId);

            let tab = currentTabProps?._langText || currentTabProps?.tab || props?.tab || 'default_title';
            tab = PresetTabs.includes(moduleId) ? langJson[moduleId] || tab : tab;

            if (isFunction(render)) {
                return (
                    <ContainerItem
                        langJson={langJson}
                        forceRender={tabPanelForceRender[moduleId]}
                        {...props}
                        tab={tab}
                        key={moduleId}
                    >
                        {render(props)}{' '}
                    </ContainerItem>
                );
            }

            // 包含不显示的  这样在处理拖拽时更好处理
            const wallets = walletLists[$id] || [];

            return (
                <ContainerItem
                    forceRender={tabPanelForceRender[moduleId]}
                    {...currentTabProps}
                    tab={tab}
                    key={moduleId}
                    langJson={langJson}
                >
                    <CardList
                        langJson={langJson}
                        id={moduleId}
                        wallets={wallets}
                        store={store}
                        cardStores={cardStores}
                        pageInstance={pageInstance}
                        cardLists={cardLists}
                        walletConfig={walletConfig}
                        cardConfig={cardConfig}
                        panelEmptyContent={panelEmptyContent}
                        draggable={draggable}
                        feedbackMessage={this.feedbackMessage}
                        getPageInstanceByPortal={this.getPageInstanceByPortal}
                        portalPageInstance={portalPageInstance}
                    />
                </ContainerItem>
            );
        });

        const containerProps = store.getContainerProps();
        const { moduleId, extraContent, tabBarExtraContent } = containerProps;

        // 是否展示刷新按钮
        showRefresh = isBoolean(showRefresh) ? showRefresh : containerProps.showRefresh;
        // 预置的页签不展示这个刷新按钮
        showRefresh = PresetTabs.includes(activeKey) ? false : showRefresh;

        const tempExtraContent = (
            <div className={`tab-bar-extra-content-wrapper `}>
                {showRefresh && (
                    <div className="tab-card-list-refresh">
                        <AnimateRotateIcon
                            animation
                            className={`iconfont icon-danchuangshuaxin`}
                            title={langJson['card-wallet-icon-refresh']}
                            onClick={(e) => {
                                if (isFunction(onRefresh)) {
                                    onRefresh(e);
                                } else {
                                    const events = store.getEventListener('refresh');
                                    events.forEach((item) => isFunction(item) && item());
                                }
                            }}
                        />
                    </div>
                )}
                <div className="tab-card-list-storage">
                    <ManagerOverlay {...this.props} />
                </div>
                <div className="tab-card-list-other">
                    {isFunction(finalTabBarExtraContent) ? finalTabBarExtraContent() : finalTabBarExtraContent}
                    {isFunction(tabBarExtraContent) ? tabBarExtraContent() : tabBarExtraContent}
                    {isFunction(extraContent) ? extraContent() : extraContent}
                </div>
            </div>
        );

        return (
            <Container
                langJson={langJson}
                tabBarStyle="line"
                onTabClick={(key) => {
                    console.log('tabKey', key);
                    store.setContainerActiveTab(key, true, () => {
                        isFunction(onTabClick) && onTabClick(key);
                    });
                }}
                activeKey={activeKey}
                // tabBarExtraContent={tempExtraContent}
                extraContent={tempExtraContent}
            >
                {items}
            </Container>
        );
    }

    render() {
        let { prefixCls, id, containerClassName, containerHeight, fieldid } = this.props;
        const style = containerHeight ? { height: containerHeight } : {};
        return (
            <div
                className={`${prefixCls}-wrapper ${containerClassName}`}
                id={`SmartCard_${id}`}
                style={style}
                fieldid={getSysFieldid(`${id || ''}_${fieldid}_area`)}
            >
                {this.getContainer()}
            </div>
        );
    }
}

SmartCard.defaultProps = defaultProps;
SmartCard.displayName = 'SmartCard';
SmartCard.useSmartCard = useSmartCard;

SmartCard.Container = Container;
SmartCard.ContainerItem = ContainerItem;
SmartCard.CardWallet = CardWallet;
SmartCard.EmptyPrompt = EmptyPrompt;
SmartCard.Message = Message;
SmartCard.Preset = Preset;
SmartCard.Skeleton = Skeleton;

export default SmartCard;
